import React, { useContext } from 'react'
import { Button } from 'react-bootstrap'
import Assets from '../../constants/images'
import { PlayIcon, VideoIcon } from '../../constants/svgs'
import { RemoveResourcePopupContext, VideoPopupContext } from '../../App'

const VideoCardSmall = ({ data, setVideoPopupItem, setSelectedResource }) => {
    const [handleVideoPopup, setHandleVideoPopup] = useContext(VideoPopupContext);
    const [handleRemoveResourcePopup, setHandleRemoveResourcePopup] = useContext(RemoveResourcePopupContext);

    return (
        <div className="video-card-small border p-2">
            <div className='d-flex '>
                <div className='img-container' onClick={() => {
                    setVideoPopupItem({ file_url: data.file_url })
                    setHandleVideoPopup(true)
                }}
                >
                    <div className='icon-container'>
                        <PlayIcon />
                    </div>
                </div>

                <div className='w-100 ms-3'>
                    <div className='mb-custom'><VideoIcon /></div>
                    <div className='sub-div d-flex w-100 justify-content-between align-items-center'>
                        <h6
                            className="m-0 p-0"
                            onClick={() => {
                                setVideoPopupItem({ file_url: data.file_url })
                                setHandleVideoPopup(true)
                            }}
                        >
                            {data?.title}
                        </h6>
                        <Button onClick={() => {
                            setHandleRemoveResourcePopup(true)
                            setSelectedResource(data)
                        }} className="btn-remove ms-2">Remove</Button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default VideoCardSmall